export const EVENT_7 = `Start trade-in clicked`;
export const EVENT_8 = `Trade-in weight submitted`;
export const EVENT_9 = `Trade-in method chosen`;
export const EVENT_10 = `Trade-in Preparation checklist complete`;
export const EVENT_11 = `Trade-in Reward method chosen`;
export const EVENT_12 = `Trade-in signed up`;
export const EVENT_13 = `Trade-in confirmed`;
export const EVENT_14 = `Trade-in confirmed additional`;
export const EVENT_16 = `Trade-in Appointment confirmed`;
export const EVENT_17 = `Trade-in Terms accepted`;
export const EVENT_18 = `Start trade-in clicked primary`;
export const EVENT_19 = `Start trade-in clicked secondary`;
export const EVENT_20 = `Start trade-in clicked tertiary`;
export const EVENT_21 = `Store Trade-In method toggled`;
export const EVENT_22 = `Mail Trade-In method toggled`;
export const EVENT_23 = `Generated shipping label`;
export const EVENT_24 = `Generated QR code`;
export const EVENT_25 = `View Store Check-in QR Code`;
export const EVENT_26 = `Accept Terms in Store`;
export const EVENT_27 = `View Gift Card`;
export const EVENT_28 = `Download receipt`;
export const EVENT_29 = `Show detailed breakdown`;
export const EVENT_31 = `Edit weight Mail-in`;
export const EVENT_32 = `Add or Edit donation`;
export const EVENT_33 = `Edit weight In-store`;
export const EVENT_34 = `Amend appointment`;

export const trackingMap = {
  [EVENT_7]: "event7",
  [EVENT_8]: "event8",
  [EVENT_9]: "event9",
  [EVENT_10]: "event10",
  [EVENT_11]: "event11",
  [EVENT_12]: "event12",
  [EVENT_13]: "event13",
  [EVENT_14]: "event14",
  [EVENT_16]: "event16",
  [EVENT_17]: "event17",
  [EVENT_18]: "event18",
  [EVENT_19]: "event19",
  [EVENT_20]: "event20",
  [EVENT_21]: `event21`,
  [EVENT_22]: `event22`,
  [EVENT_23]: `event23`,
  [EVENT_24]: `event24`,
  [EVENT_25]: `event25`,
  [EVENT_26]: `event26`,
  [EVENT_27]: `event27`,
  [EVENT_28]: `event28`,
  [EVENT_29]: `event29`,
  [EVENT_31]: `event31`,
  [EVENT_32]: `event32`,
  [EVENT_33]: `event33`,
  [EVENT_34]: `event34`,
};
